import React, { FC, useEffect, useState } from 'react';
import { InputGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useParams } from 'react-router-dom';
import { YoGameEnvironmentRoles } from '../../config/yo-game-environment-roles';
import { GameEnvironmentSelector } from '../game-environment-selector';
import { useAuthUser } from '@yakoffice/yakoffice-firebase';
import styles from '../data-source/dataSource.module.sass';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/cjs/Container';
import { observer } from 'mobx-react-lite';

interface InputProps {
    title: string;
    handleGameEnvironmentChange: (gameEnvironmentId: string) => void;
    handleSearchItem: (itemId: string) => void;
}

export const PlayersHeader: FC<InputProps> = observer(({ handleGameEnvironmentChange, handleSearchItem, title }) => {

    const authUser = useAuthUser();
    const { projectId, itemId } = useParams() as { projectId: string, itemId: string };
    const [searchItemId, setSearchItemId] = useState<string>('');

    const handleSearchItemIdChanged = (value: string) => setSearchItemId(value);

    const handleKeyPress = (event: any) => {

        if (event.keyCode === 13) {
            event.preventDefault();
            handleSearchItem(searchItemId);
        }
    };

    useEffect(() => {
        setSearchItemId(itemId ?? '');
    }, [itemId, setSearchItemId]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);

    return <Container fluid className={styles.stickyContainer}>
        <div className={styles.headerTitle}>
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.searchForm}>
                <InputGroup>
                    <Form.Control
                        className={styles.userSearchField}
                        type="text"
                        id="search-input"
                        placeholder="Please enter a Player ID to search for..."
                        value={searchItemId}
                        onChange={(e) => handleSearchItemIdChanged(e.target.value)}
                        data-testid="txtSearch"
                    />
                </InputGroup>
            </div>
            <Col xs="auto">
                {authUser && <GameEnvironmentSelector
                    gameEnvironmentFilter={geId => authUser.hasGameEnvironmentRoleClaim(projectId, geId, YoGameEnvironmentRoles.ViewPlayers)}
                    handleGameEnvironmentChange={handleGameEnvironmentChange}
                    data-testid="ddlSearchGameEnvironment"
                />}
            </Col>
        </div>
    </Container>;
});
